import type { ToolRendererProps } from '@cotera/client/v0/chat/tool-renderers';
import { coco } from '@cotera/api';

const { isWorkflowToolKey } = coco;

export function isWorkflowToolRendererKey(toolKey: string): boolean {
  return isWorkflowToolKey(toolKey.replaceAll('_', '/'));
}

export type WorkflowToolRendererProps = ToolRendererProps & {
  readonly?: boolean;
};
